import React from 'react';
import { m } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../../utils/checkout';
export function FinalCTA() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-66" data-mp="3mtrzkafbyh2x">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-67" data-mp="3mt8qzkbkl51k">
        <h2 className="font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-68" data-mp="3rs38mixswnk3">
          Tu próximo entrenamiento no tiene que empezar desde cero.
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-3 text-left text-base leading-relaxed text-muted sm:text-center" data-id="element-69" data-mp="3hv6y67ocdrcw">
          <p data-id="element-70" data-mp="33vxta45l6jo8">
            Deja de perder horas buscando ejercicios que después tienes que adaptar y organizar por tu
            cuenta.
          </p>
          <p data-id="element-71" data-mp="38vtxa3eaab3s">
            Con MISTER PRO tienes un sistema de planificación y recursos técnicos y tácticos para preparar
            tus sesiones con más claridad.
          </p>
          <p className="font-semibold text-white" data-id="element-72" data-mp="171uoboomw5u9">Elige el objetivo, consulta las tareas y adapta el entrenamiento a tu equipo.</p>
        </div>

        <m.a href={CHECKOUT_URL} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="group mx-auto mt-8 flex max-w-sm flex-col items-center gap-3 rounded-2xl border border-lime/30 bg-bg-primary p-6 text-center transition-colors hover:border-lime/60" data-id="element-73" data-mp="la280px1esbl">
          <span className="font-heading text-sm font-semibold uppercase tracking-wide text-muted" data-id="element-74" data-mp="2b7pr6yd79qo">
            ⚽ MISTER PRO: La Pizarra del Entrenador
          </span>
          <span className="font-heading text-3xl font-bold text-white" data-id="element-75" data-mp="g834ng1arven">13,99€</span>
          <span className="text-[11px] font-semibold uppercase tracking-wide text-lime" data-id="element-76" data-mp="bdh1u19a7b66">
            6 tomos + 5 bonos · Acceso digital inmediato
          </span>
          <span className="mt-2 inline-flex items-center gap-2 rounded-xl bg-lime px-6 py-3 text-sm font-semibold uppercase text-bg-primary transition-colors group-hover:bg-lime-hover" data-id="element-77" data-mp="1mphvnul05pss">
            Quiero acceder a MISTER PRO
            <ArrowRightIcon size={16} className="transition-transform group-hover:translate-x-1" data-id="element-78" data-mp="pade7hys0k1y" />
          </span>
        </m.a>
      </div>
    </section>;
}